module.exports = __webpack_public_path__ + "img/lottery.74c0443.webp";